import { Roles } from 'common/constants/roles';

export function hasAnyRole(currentUserRoles: Roles[], allowedRoles: Roles[]): boolean {
    if (!currentUserRoles) {
        return false;
    }

    return currentUserRoles.some(role => allowedRoles.includes(role));
}

/**
 * Returns true if button should be disabled (user lacks ANY of the allowed roles)
 */
export const disableIfMissingAnyRole = (currentUserRoles: Roles[], allowedRoles: Roles[]): boolean => {
    return !hasAnyRole(currentUserRoles, allowedRoles);
};

/**
 * Returns true if button should be disabled (user lacks ALL of the required roles)
 */
export const disableIfMissingAllRoles = (currentUserRoles: Roles[], requiredRoles: Roles[]): boolean => {
    const hasAllRoles = requiredRoles?.every(x => currentUserRoles.includes(x));
    return !hasAllRoles;
};
